// Built and deployed by the shared cicd-foundations pipeline (profiles-cloud-run-service).
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';

// Language services — initialized with web's own react-i18next to avoid multiple React instances
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from 'translations/i18n/en.json';
import es from 'translations/i18n/es.json';
import de from 'translations/i18n/de.json';
import ja from 'translations/i18n/ja.json';
import { DEFAULT_LANGUAGE, getPreferredLanguage, SUPPORTED_LANGUAGES } from './i18n/language';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
    de: { translation: de },
    ja: { translation: ja },
  },
  lng: getPreferredLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: SUPPORTED_LANGUAGES,
  debug: process.env.REACT_APP_LOGING_MODE === 'DEV',
});

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
